export type NewProjectSourceType = "GITHUB" | "CLOUD" | "GOOGLE_DRIVE";

export function canProceedInNewProjectFlow(args: {
  sourceType: NewProjectSourceType;
  step: number;
  hasSelectedRepo: boolean;
  projectName: string;
}): boolean {
  const trimmedName = args.projectName.trim();
  if (args.sourceType === "CLOUD") {
    return trimmedName.length > 0;
  }
  if (args.sourceType === "GOOGLE_DRIVE") {
    if (args.step === 1) {
      return args.hasSelectedRepo;
    }
    return trimmedName.length > 0;
  }
  if (args.step === 1) {
    return args.hasSelectedRepo;
  }
  return trimmedName.length > 0;
}
